import { DateTime } from "luxon"

import { DATE_FORMAT } from "@/constants"

const getHoursMinutesTime = (datetime: DateTime) => {
    return datetime.toFormat(DATE_FORMAT.HOUR_MINUTES_MERIDIEM).toLowerCase().replace(/\s/g, "")
}

const getTimezoneAbbreviation = () => DateTime.now().toFormat(DATE_FORMAT.TIMEZONE_ABBREVIATED)

const formatShortMonthDay = (date: string) =>
    DateTime.fromISO(date).isValid ? DateTime.fromISO(date).toFormat(DATE_FORMAT.SHORT_MONTH_DAY_NOT_PADDED) : ""

const formatMonthDayYear = (date: string) =>
    DateTime.fromISO(date).isValid ? DateTime.fromISO(date).toFormat(DATE_FORMAT.MONTH_DAY_YEAR) : ""

export { getHoursMinutesTime, getTimezoneAbbreviation, formatShortMonthDay, formatMonthDayYear }
